import usePlaceholder from 'articleEditor/hooks/usePlaceholder';
import { MyListItemElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';

type ListItemBlockProps = RenderElementProps & {
  element: MyListItemElement;
};

export default function ListItemBlock({
  element,
  attributes,
  children,
}: ListItemBlockProps): JSX.Element {
  const placeholder = usePlaceholder({
    placeholder: 'Type something...',
    element,
  });

  return (
    <li {...attributes} data-placeholder={placeholder}>
      {children}
    </li>
  );
}
